import Endpoint from './endpoint/endpoint.constants';

export default {
  Endpoint,
  debounce: {
    filter: 400,
    page: 200,
    sort: 200,
    globalSearch: 200,
    autocomplete: 100
  },
  xPagination: 'x-pagination'
};
